<template>
	<div class="data-list">
		<functional-zone
			v-if="btnList || custom || alert || hint"
			:btnList="btnList"
			:custom="custom"
			:alert="alert"
			:hint="hint"
		></functional-zone>
		<!-- 表格 -->
		<el-table
			:data="data"
			ref="table"
			:summary-method="getSummaries"
			:show-summary="showSummary"
			:highlight-current-row="highlightCurrentRow"
			:row-class-name="tableRowClassName"
			:header-row-class-name="headerRowClassName"
			:header-cell-style="headerCellStyle"
			:height="height"
			:max-height="maxHeight"
			v-loading="loading"
			:element-loading-text="loadingText"
			:show-header="isShowHeader == false ? false : true"
			:border="border"
			:size="size"
			:row-key="rowKey"
			:expand-row-keys="expandRowKeys"
			:tree-props="treeProps"
			@current-change="currentChange"
			@sort-change="sortChange"
			@selection-change="selectionChange"
			@expand-change="expandChange"
			@select="select"
		>
			<!-- 多选框 -->
			<el-table-column
				type="selection"
				width="55"
				:selectable="selectable"
				:reserve-selection="reserveSelection"
				v-if="selection"
			></el-table-column>

			<template v-for="(col, index) in column">
				<el-table-column
					v-if="col.show ? col.show(col) : true"
					:label="col.label"
					:align="col.align"
					:min-width="col.minWidth"
					:max-width="col.maxWidth"
					:width="col.width"
					:sortable="col.sortable"
					:show-overflow-tooltip="col.showOverflowTooltip"
					:key="index"
					:class-name="col.type == 'tableExpand' ? 'expandBtn' : ''"
					:type="getType(col)"
					:fixed="col.fixed"
				>
					<!-- 表头渲染区域 -->
					<template slot="header" slot-scope="{ column, _index }">
						<renderHeader
							:renderHeader="renderHeader"
							:column="column"
							:_index="_index"
							:index="index"
						/>
					</template>

					<template slot-scope="scope">
						<customComponent
							v-if="col.type === 'custom'"
							:component-name="col.componentName"
							:scope="scope"
							:table-data="col"
						></customComponent>
						<component
							v-else
							:is="col['type'] || 'defaultText'"
							:scope="scope"
							:table-data="col"
							:key="index"
							v-bind="{ ...$attrs, ...col }"
							v-on="$listeners"
						></component>
					</template>
				</el-table-column>
			</template>
		</el-table>
		<!-- 分页 -->

		<div>
			<el-pagination
				v-if="page"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:page-sizes="[5, 10, 20, 30, 40]"
				:page-size="page.pageSize"
				:currentPage="page.currentPage"
				layout="total, sizes, prev, pager, next"
				:total="page.totalRecords"
				:class="{ webclient: this.tableStyle.name == 'webclient' }"
			></el-pagination>
		</div>
	</div>
</template>
<script>
import columnBtn from './columnBtn';
import defaultText from './defaultText';
import customComponent from '@/components/tools/customComponent';
import skySortSelect from '@/components/iglobalwin/formComponents/sky-sortSelect';
import btnClick from './btnClick';
import remark from './remark';
import progressItem from './progress';
import expandBtn from './expandBtn';
import account from './account/index.js';
import tableExpand from './tableExpand';
import tag from './tag.vue';
import functionalZone from '@/components/iglobalwin/dataList/functionalZone.vue';
import previewUploadFile from './preview-uploadimg';
import renderHeader from './components/renderHeader.vue';
import multilineListItems from './multilineListItems.vue';
import searchText from './searchText';
import linkClick from './linkClick';
import switchBtn from './switchBtn';
import multipleParames from './multipleParames';
import defaultTextUnitCustom from './defaultTextUnitCustom';

export default {
	name: 'data-list',
	props: {
		// 表格属性值
		showSummary: {
			// 是否显示合计行
			required: false,
		},
		getSummaries: {
			// 自定义合计逻辑
			required: false,
		},
		'highlight-current-row': {
			// 是否高亮当前行
			required: false,
		},
		data: {
			// 显示的数据
			required: true,
		},
		height: {
			// 固定表头高度
			required: false,
		},
		size: {
			// Table 的尺寸
			required: false,
		},
		maxHeight: {
			// 最大高度
			required: false,
		},
		loading: {
			// 加载动画
			required: false,
		},
		loadingText: {
			// 加载动画文字
			type: String,
			default: '数据加载中',
		},
		isShowHeader: {
			// 是否显示表头
			required: false,
		},
		border: {
			// 是否带有纵向边框
			default: false,
			type: Boolean,
		},
		columns: {
			required: true,
		},
		page: {
			// 分页
			required: false,
		},
		maxWidth: {
			// 最大宽度
			required: false,
		},
		selection: {
			// 是否显示多选框
			required: false,
		},
		selectable: {
			// 多选筛选
			type: Function,
			required: false,
		},
		tableStyle: {
			required: false,
			default: () => {
				return { name: 'default' };
			},
		},
		// 表头样式
		headerCellStyle: {
			required: false,
		},
		// 修改分页背景色
		webclient: {
			type: Boolean,
			default: false,
		},
		btnList: {
			type: Array,
			required: false,
		},
		custom: {
			type: Object,
			required: false,
		},
		alert: {
			type: Object,
			required: false,
		},
		hint: {
			type: Object,
			required: false,
		},
		rowKey: {
			type: [Function, String],
			required: false,
		},
		expandRowKeys: {
			type: Array,
			required: false,
		},
		reserveSelection: {
			type: Boolean,
			default: false,
		},
		treeProps: {
			type: Object,
			default: () => {
				return {};
			},
		},
		// 筛选数据
		sort: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			column: [],
			val: null,
		};
	},
	methods: {
		getType(col) {
			switch (col.type) {
				case 'tableExpand':
					return 'expand';
				case 'index':
					return 'index';
				default:
					return undefined;
			}
		},
		// 表格属性回调
		// 当前行发生改变触发
		currentChange(val) {
			this.$emit('current-change', val);
		},
		// 排序规则发生改变触发
		sortChange(column) {
			this.$emit('sort-change', column);
		},
		valueChanged(column) {
			this.$emit('valueChanged', column);
		},
		select(column, row) {
			let refs = this.$refs.table;
			this.$emit('select', column, row, refs);
		},
		selectionChange(column) {
			let refs = this.$refs.table;
			this.$emit('selection-change', column, refs);
		},
		// 对某行数据选中状态的管理
		toggleRowSelection(rows, selected) {
			rows.forEach(row => {
				this.$refs.table.toggleRowSelection(row, selected);
			});
		},
		// 行className回调
		tableRowClassName() {
			return `${this.tableStyle.name}-style`;
		},
		// 表头行calssName回调表头行calssName回调
		headerRowClassName() {
			return `${this.tableStyle.name}-header`;
		},

		handleSizeChange(val) {
			// pageSize 改变时会触发
			this.$emit('page-size-changed', val);
		},
		handleCurrentChange(val) {
			// currentPage 改变时会触发
			this.$emit('page-changed', val);
		},
		/**
		 * 渲染表格表头
		 * @param {Function} h - Vue 创建VNode的函数
		 * @param {Object} params - 表头参数 { column, $index }
		 * @param {number} index - 列索引
		 * @returns {VNode|string} 表头渲染结果
		 */
		renderHeader(h, { column, $index }, index) {
			// 解构赋值简化变量获取，避免重复this访问
			const { column: columns, data, sort, $refs, valueChanged, sortChange, closeSelect } = this;
			const currentCol = columns[index];

			// 守卫：若当前列配置不存在，返回默认值避免报错
			if (!currentCol) return column?.label || '';

			// 1. 默认文本类型样式设置（提前判断，逻辑更清晰）
			if (currentCol.type === 'defaultText') {
				column.className = 'default-header-Text';
			}

			// 2. 自定义组件渲染（优先级最高）
			if (currentCol.customize) {
				return h(currentCol.columnsType, {
					props: {
						bind: currentCol.bind,
						label: currentCol.label,
						placeholder: currentCol.placeholder,
						// 补充默认值，避免组件接收undefined
						...currentCol.componentProps, // 支持额外透传组件属性，增强灵活性
					},
					on: {
						// 简化函数绑定，避免额外闭包
						valueChanged: valueChanged,
					},
				});
			}

			// 3. 排序选择器渲染（有选项或内容时）
			if (currentCol.options || currentCol.content) {
				// 计算表头标题（提取独立逻辑，提升可读性）
				const headerTitle =
					typeof currentCol.labelFn === 'function' ? currentCol.labelFn(data) : currentCol.label;

				// 计算当前排序值（简化三元表达式）
				const currentSortValue = currentCol.sort === sort.sortName ? sort.sortType || '' : '';

				return h(skySortSelect, {
					props: {
						options: currentCol.options,
						title: headerTitle,
						content: currentCol.content,
						value: currentSortValue,
					},
					ref: `sort${$index}`, // 简化模板字符串
					on: {
						sortChanged: val => {
							// 简化变量获取，直接使用解构后的$refs
							const headerRefs = $refs.table?.$refs.tableHeader?.$refs;
							if (headerRefs) closeSelect(headerRefs, $index);

							sortChange({
								column,
								order: val,
								sort: currentCol.sort,
							});
						},
					},
				});
			}

			// 4. 普通文本渲染（默认情况）
			return typeof currentCol.labelFn === 'function'
				? currentCol.labelFn(data)
				: currentCol.label || column.label;
		},
		closeSelect(list, index) {
			_.each(list, (item, idx) => {
				if (idx !== `sort${index}`) {
					item.reset();
				}
			});
		},
		expandChange(row, arr) {
			this.$emit('expand-change', { row, arr });
		},
		clearSelection() {
			this.$refs.table.clearSelection();
		},
	},
	components: {
		...account,
		columnBtn,
		defaultText,
		customComponent,
		btnClick,
		skySortSelect,
		remark,
		progressItem,
		expandBtn,
		tableExpand,
		tag,
		functionalZone,
		previewUploadFile,
		renderHeader,
		multilineListItems,
		searchText,
		multipleParames,
		linkClick,
		switchBtn,
		defaultTextUnitCustom,
	},
	watch: {
		columns: {
			handler: function (val) {
				this.column = _.cloneDeep(val);
			},
			immediate: true,
			deep: true,
		},
	},
};
</script>
<style lang="scss">
$color: rgba(246, 247, 251, 0.5);
$headerColor: #4a4a4a;
$fontSize: 12px;
$cellColor: rgba(233, 233, 233, 1);
$scrollHeight: 10px;

@mixin bg-color($color) {
	background-color: $color;
}

// border属性样式修改
.el-table--border th {
	border: 1px solid transparent;
	border-right: 1px solid rgba(223, 223, 223, 0.5);
	border-left: 1px solid $color;
}

.el-table--border,
.el-table--group {
	border: 1px solid $color;
}

.el-table--border td {
	border: 1px solid transparent;
}

// 多选框属性
.mixture-style td.el-table-column--selection .cell,
.mixture-header th.el-table-column--selection .cell {
	text-align: center;
}

.el-table--border td:first-child .cell {
	text-align: center;
}

.el-table--border th:first-child .cell {
	padding-left: 0;
	text-align: center;
}

// td padding
.mixture-style td .cell,
.nest-style td .cell {
	padding: 0 10px;
}

// th padding
.mixture-header th .cell,
.nest-header th .cell {
	padding: 0 10px;
}

// th padding
// .el-table td,
// .el-table th {
//   padding-top: 0;
//   padding-bottom: 0;
// }

.data-list th .cell {
	width: 100%;
	// height: 34px;
	// line-height: 34px;
}

.el-table td,
.el-table th.is-leaf {
	max-width: 300px;
}

.el-table .warning-row {
	@include bg-color(oldlace);
}

.el-pagination {
	text-align: right;
	padding: 20px 30px;
	background-color: #fff;
	// background-color: transparent;
}

.data-list.webclient .default-header th {
	color: #000;
	background-color: #fafafa;
}

// .data-list.webclient .el-table--enable-row-hover .el-table__body tr:hover > td {
//   background: #e9f4ff !important;
// }
.el-table--enable-row-transition .el-table__body .mixture-style:hover > td {
	background: #e9f4ff !important;
}

.el-table--enable-row-transition .el-table__body .nest-style:hover > td {
	background: #d8d8d8 !important;
}

.mixture-style {
	.default-header-Text {
		.cell {
			padding-left: 40px !important;
		}
	}

	td {
		border-top: 5px solid $color;
		border-bottom: 1px solid $color;
	}

	.el-table__expand-icon > .el-icon {
		display: none;
	}

	.expandBtn .cell .el-table__expand-icon .el-icon {
		display: block !important;
	}
}

.secondPage-style {
	@extend .mixture-style;

	td {
		border-top: none;
		border-bottom: 1px solid #d8d8d8;
	}
}

.secondPage-header {
	@extend .mixture-header;

	th.is-leaf {
		border-bottom: 1px solid #d8d8d8 !important;
	}
}

.mixture-header {
	.default-header-Text .cell {
		padding-left: 40px !important;
	}

	th.is-leaf {
		border-bottom: 5px solid $color;
		font-size: $fontSize;
		color: $headerColor;
		padding: 0 0;
		line-height: 30px;

		div {
			overflow: visible;
			height: 34px;
			line-height: 34px;
			padding: 0;
		}

		.caret-wrapper {
			width: 18px;
		}
	}
}

.el-table__expanded-cell[class*='cell'] {
	padding: 0;
}

.caret-wrapper {
	width: 18px;
}

tbody .mixture-style td {
	padding: 10px 0;
}

tbody .nest-style td {
	padding: 10px 0;

	.cell {
		padding-left: 0;
	}
}

.default-style th {
	@include bg-color($cellColor);

	font-size: $fontSize;
	padding: 8px 0;
	color: rgba(51, 51, 51, 1);
}

.nest-style {
	@include bg-color(#f5f7fb !important);

	.el-table__expand-icon > .el-icon {
		display: none;
	}

	.nest-header th {
		padding: 0;
		line-height: 30px;
	}
}

.nest-header th {
	padding: 0;

	.cell,
	div {
		overflow: visible;
		padding-right: 0;
		padding-left: 0;
	}

	.cell {
		line-height: 30px;
		color: $headerColor;
		font-size: $fontSize;
	}

	.el-dropdown {
		line-height: 0;
	}

	@include bg-color(#e4e4e4);
}

.webclient-style {
	@include bg-color(#fff !important);

	// .cell {
	// 	padding: 0 16px;
	// }

	.nest-header th {
		padding: 0;
		line-height: 30px;
	}
}

.webclient-header th {
	padding: 10px 16px;

	.cell,
	div {
		overflow: visible;
		padding-right: 0;
		padding-left: 0;
	}

	.cell {
		line-height: 30px;
		color: $headerColor;
		font-size: $fontSize;
	}

	.el-dropdown {
		line-height: 0;
	}

	@include bg-color(#fafafa);
}

.el-table .grey-header th {
	background: #f1f4f9;
}
.el-table .el-table__fixed {
	height: 100% !important;
}
.el-table.el-table--scrollable-x .el-table__fixed {
	height: calc(100% - #{$scrollHeight}) !important;
}
</style>

<style lang="scss" scoped>
.data-list {
	::v-deep .el-table {
		.el-table__body-wrapper {
			// 改变滚动条样式
			&::-webkit-scrollbar {
				width: 10px;
				height: 10px;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #e8e8e8;
				height: 50px;
				border-radius: 6px;
			}

			&::-webkit-scrollbar-track {
				background-color: #fff;
				border-radius: 2px;
			}
		}
	}
}
</style>
